import React from 'react';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import emptyImage from '../../../assets/nodata.jpg';

export default function EmptyVesselInfo() {
  return (
    <>
      <ComponentPageHeader subHeading="VESSEL" />
      <div className="empty_vessel_container">
        <img height={400} width={600} src={emptyImage} alt="Empty Vessel" className="empty_vessel_image" />
        Looks like there is no data available for this vessel.
      </div>
    </>
  );
}
